// dependencies
import { useNavigate } from "react-router";

// icons
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaRedditAlien } from "react-icons/fa";

// style
import styles from "./css/Footer.module.css"



const Footer = () => {
    let navigate = useNavigate();

    const handleNavigatePage = (page) => {
        navigate(page)
    }
    
    return ( 
        <div className={styles.footerContainer}>
            <div className={styles.footer}>
                {/* name | pages | socials */}
                <div className={styles.footerInfo}>
                    {/* name */}
                    <div className={styles.nameContainer}>
                        <div className={styles.name}>CodeNameHaar</div>
                        <div className={styles.title}>Full Stack Developer</div>
                    </div>

                    {/* pages */}
                    <div className={styles.pages}>
                        <div className={styles.page} onClick={() => handleNavigatePage("/CodeNameHaar")}>Home</div>
                        <div className={styles.page} onClick={() => handleNavigatePage("/projects")}>Projects</div>
                        <div className={styles.page} onClick={() => handleNavigatePage("/contact")}>Contact</div>
                    </div>
                    
                    {/* socials */}
                    <div className={styles.socials}>
                        <a href="https://github.com/CodedBeats" target="_blank" rel="noopener noreferrer">
                            <FaGithub className={styles.social} />
                        </a>
                        <a href="https://www.linkedin.com/in/luca-haar-a2229220a" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin className={styles.social} />
                        </a>
                        <a href="https://www.reddit.com/user/CodedBeatss/" target="_blank" rel="noopener noreferrer">
                            <FaRedditAlien className={styles.social} />
                        </a>
                    </div>
                </div>

                {/* licence | PP & ToS */}
                <div className={styles.extra}>
                    <div>© 2025 Luca Haar. All rights reserved.</div>
                    <div className={styles.legalShizContainer}>
                        <div className={styles.legalShiz}>luca.haar@icloud.com</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
 
export default Footer